import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Logout } from "../../../view/pages/Logout/Logout";
import { GET_POPUP_ENUMS } from "../../../navigation/NavConstant";
import { ModalLayout } from "../../../view/containers/Layout/ModalLayout";
import ChangePassword from "../../Modules/Users/UpdatePassword";
import ChangeSettings from "../../Modules/Users/UpdateSettings";
import ChangeTheme from "../../Modules/Users/UpdateTheme";

const popups = {
  [GET_POPUP_ENUMS.logout]: Logout,
  [GET_POPUP_ENUMS.changePasword]: ChangePassword,
  [GET_POPUP_ENUMS.changeSettings]: ChangeSettings,
  [GET_POPUP_ENUMS.changeTheme]: ChangeTheme,
};

function GetParameterPopups({ popUp }: { popUp: string }) {
  const Component = popups[popUp];

  if (!Component) {
    return <></>;
  }

  return <Component />;
}

export function ModalWrapper() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {}, []);

  return (
    <>
      {searchParams.get("popup") && (
        <ModalLayout>
          <GetParameterPopups popUp={searchParams.get("popup") || ""} />
        </ModalLayout>
      )}
    </>
  );
}
